import React from "react";
import QRCodeReact from "react-qr-code";
import { ModalSettings, withFocusable } from "../../services/visualLibraryService";
import FreeLogo from "../../components/FreeLogo";
import Logo from "../../components/Logo";
import { i18n } from "../../services/i18nService";
import {
  ButtonStyled,
  QRCodeWrapper,
  TextStyled,
  LoginSeparator,
  ChampionsTrophySubscriptionDetail,
  CTDetailLogo,
  CTSubscriptionDetailText
} from "./styles/Styled";
import { PinItemStyled, PinContainerStyled } from "../../pages/PinSignup/styles/Styled";
import { getAppState } from "../../state";
import { SettingsSelector } from "../../services/visualLibraryService";

const championstrophysubscription = "/images/championstrophysubscription.png";
const iconchampionstrophysubscriptionsdetail = "/images/iconchampionstrophydetail.png";

const ButtonFocus = withFocusable(ButtonStyled);

const CTSubscriptionDetailParagraph = `By upgrading to STARZPLAY Max - Yearly Plan, you will get immediate access to your new subscription
                      benefits, and a full payment for the new plan will be charged upfront. Apple will refund any unused
                      portion of your current plan on a prorated basis.`;
const isCTTagEnabled = false;

/**
 * This component shows a modal on top of the rest of the visual elements of the app. Its visibility is managed through
 * the application state actions showSettingsModal and hideSettingsModal. The component receives a configuration object
 * as a prop and displays and behaves differently depending on the configuration parameters received.
 * @param {Object} modalConfig  Configuration object with parameters that can define the modal's appearance and
 * behavior. These are the possible values it can receive:
 * - modalTitle: The title of the modal in string format (optional)
 * - modalText: The body of the modal in string format.
 * - buttons: An array of objects defining the list of buttons to show. Each button can have the following properties:
 *    > label: The text that will be displayed on the button in string format
 *    > focusPath: A unique string value to serve as the identifier of the button for the focus manager
 *    > buttonHandler: A function that will be executed then the button is selected
 * @return {React.Component}
 */
export default ({ modalConfig }) => {
  const isRTL = i18n.getDirection() === i18n.directions.RIGHT_TO_LEFT;
  const [i, setI] = React.useState(30);

  React.useEffect(() => {
    return () => {
      (async () => {
        if (modalConfig?.promptRef?.current) {
          if (getAppState().signupPromptActive) getAppState().signupPromptActive = false;
        }
      })();
    };
  }, []);
  if (modalConfig.modalClosingTimer) {
    React.useEffect(() => {
      const interval = setInterval(() => {
        if (i === 0) {
          clearInterval(interval);
        } else {
          setI(prevI => prevI - 1);
        }
      }, 1000);
      return () => {
        clearInterval(interval);
      };
    }, [i]);
  }
  modalConfig.loggedInButton = modalConfig.loggedInButton && modalConfig.loggedInButton.filter(Boolean);
  let _allButtons = [];
  _allButtons =
    modalConfig.buttons && modalConfig.buttons.length > 0 ? [..._allButtons, ...modalConfig.buttons] : [..._allButtons];
  _allButtons =
    modalConfig.loggedInButton && modalConfig.loggedInButton.length > 0
      ? [..._allButtons, ...modalConfig.loggedInButton]
      : [..._allButtons];

  _allButtons =
    modalConfig.langBtns && modalConfig.langBtns.length > 0
      ? [..._allButtons, ...modalConfig.langBtns]
      : [..._allButtons];
  return (
    <ModalSettings
      descriptionFontWeight={modalConfig.descriptionFontWeight}
      headingText={modalConfig.modalTitle}
      headingTextFontSize={modalConfig.modalTitleFontSize}
      headingTextLineHeight={modalConfig.modalHeadingTextLineHeight}
      headingTextSpacing={modalConfig.modalHeadingSpacing}
      mainText={modalConfig.modalText}
      disclaimer1={modalConfig.disclaimer1}
      disclaimer2={modalConfig.disclaimer2}
      subTitle={modalConfig.subTitle}
      isSwitchPlan={modalConfig.isSwitchPlan}
      headerIcon={modalConfig?.showPreemiumLogo === true ? <Logo /> : <FreeLogo />}
      isRTL={isRTL}
      type={modalConfig?.type}
      features={modalConfig.features}
      epgStatus={modalConfig?.epgStatus}
      epgRenderStatus={modalConfig?.epgRenderStatus}
      epgTime={modalConfig?.epgTime}
      epgTags={modalConfig?.epgTags}
      epgChannelImage={modalConfig?.epgChannelImage}
      subscriptionLogo={modalConfig?.subscriptionLogo}
      priceComponent={modalConfig?.priceComponent}
      subscriptionLogoChildLogosList={modalConfig?.subscriptionLogoChildLogosList}
      isUserLogged={modalConfig.isUserLogged}
      promptRef={modalConfig?.promptRef}
      selectedSubscriptionLogo={modalConfig.selectedSubscriptionLogo}
      lang={i18n.getLocale()}
      modalIconSectionDisplay={modalConfig.modalIconSectionDisplay}
      isPinBox={modalConfig.isPinBox}
      modalContentHeight={modalConfig.modalContentHeight}
      iconWrapperMarginTop={modalConfig.iconWrapperMarginTop}
      setFocus={modalConfig.setFocus}
      profileImagePopupData={modalConfig.profileImage}
      getSelectedAvatar={modalConfig?.getSelectedAvatar}
      isCategoriesModal={modalConfig?.isCategoriesModal}
      onClickBack={modalConfig.onClickBack}
      seasonPassData={modalConfig?.seasonPassData}
      upgradeDisclaimer={modalConfig?.upgradeDisclaimer}
      videoCommerceProductDetail={modalConfig?.videoCommerceProductDetail}
      backIcon={modalConfig.backIcon}
    >
      {modalConfig.qrCodeURL && (
        <QRCodeWrapper border={modalConfig?.videoCommerceProductDetail ? "default" : "small"}>
          <QRCodeReact value={modalConfig.qrCodeURL} />
        </QRCodeWrapper>
      )}
      {modalConfig.isPinBox && (
        <PinContainerStyled userLocale={"en"} isPinBoxModal={modalConfig.isPinBox}>
          {modalConfig.pin &&
            modalConfig.pin.split("").map((pinChar, index) => (
              <PinItemStyled
                userLocale={"en"}
                key={`pin-${index}-${pinChar}`}
                isPinBoxModal={modalConfig.isPinBox}
                fontSize="xxmedium"
                borderRadius="large"
              >
                {pinChar}
              </PinItemStyled>
            ))}
        </PinContainerStyled>
      )}
      {modalConfig.buttons &&
        modalConfig.buttons.map((button, i) => (
          <>
            {isCTTagEnabled && (
              <ChampionsTrophySubscriptionDetail>
                <CTDetailLogo src={iconchampionstrophysubscriptionsdetail} />
                <CTSubscriptionDetailText text={CTSubscriptionDetailParagraph} />
              </ChampionsTrophySubscriptionDetail>
            )}
            <ButtonFocus
              label={button?.label?.toUpperCase()}
              focusPath={button.focusPath}
              dataSnUp={getClosestButtonFocusPath("up", _allButtons, i)}
              dataSnDown={getClosestButtonFocusPath("down", _allButtons, i)}
              displayBlock={true}
              dataSnLeft={getClosestButtonFocusPath("left", _allButtons, i)}
              dataSnRight={getClosestButtonFocusPath("right", _allButtons, i)}
              onEnterPress={() => button.buttonHandler()}
              onMouseUp={() => button.buttonHandler()}
              size="medium"
              spacing="xsmall"
              key={button.label}
              isWidthIncrease={modalConfig.isWidthIncrease}
              forVerticalSideModal={modalConfig?.type}
              isMarginTop={modalConfig.isSwitchPlan && i18n.getLocale() === "fr" ? false : true}
              lang={i18n.getLocale()}
              noborder={button?.noborder && button?.noborder}
              customCSS={button?.customCSS}
              isSwitchPlan={modalConfig.isSwitchPlan}
              isModalCloseBtn={button.isModalCloseBtn}
              customMarginTop={button.customMarginTop}
              customWidth={button.customWidth}
              buttonType={window.location.pathname.startsWith("/admn") ? "admn" : undefined}
            />
          </>
        ))}
      {modalConfig.modalClosingTimer && (
        <TextStyled text={`${modalConfig.modalClosingTimer} ${i < 10 ? `0${i}` : i}`} size="medium" />
      )}
      {modalConfig.loggedInButton && modalConfig.loggedInButton.length > 0 && (
        <LoginSeparator text={i18n.get("pages.livePage.modals.moreDetails.alreadyAccount")} />
      )}
      {(modalConfig.loggedInButton && modalConfig.loggedInButton.length) > 0
        ? modalConfig.loggedInButton.map((button, i) => (
            <ButtonFocus
              label={button?.label?.toUpperCase()}
              focusPath={button.focusPath}
              dataSnUp={getClosestButtonFocusPath("up", _allButtons, i + 1)}
              dataSnDown={getClosestButtonFocusPath("down", _allButtons, i + 1)}
              displayBlock={true}
              dataSnLeft={getClosestButtonFocusPath("left", _allButtons, i + 1)}
              dataSnRight={getClosestButtonFocusPath("right", _allButtons, i + 1)}
              onEnterPress={() => button.buttonHandler()}
              onMouseUp={() => button.buttonHandler()}
              size="medium"
              spacing="xsmall"
              key={button.label}
              isWidthIncrease={modalConfig.isWidthIncrease}
              forVerticalSideModal={modalConfig?.type}
              isMarginTop={false}
              lang={i18n.getLocale()}
              noborder={button?.noborder && button?.noborder}
              buttonType={window.location.pathname.startsWith("/admn") ? "admn" : undefined}
            />
          ))
        : null}
      {modalConfig.langBtns && modalConfig.langBtns.length > 0 && (
        <SettingsSelector
          items={modalConfig.langBtns.map((item, i) => ({
            key: item.languageCode,
            title: item.title,
            active: item.active,
            focusPath: item.title,
            onLeft: () => {},
            onRight: () => {},
            onDown: () => modalConfig.setFocus(getClosestButtonFocusPath("down", _allButtons, i)),
            onUp: () => modalConfig.setFocus(getClosestButtonFocusPath("up", _allButtons, i))
          }))}
          onItemSelected={item => modalConfig.onItemSelected(item)}
          titleFontSize="xmedium"
          titleFontWeight="bold"
          isFromParentalControl={true}
          isLanguageModel={modalConfig.isLanguageModel}
        />
      )}
    </ModalSettings>
  );
};

/**
 * For a given button within a list of buttons, this function returns the focus path of the immediately closest button
 * in a given direction. If there is no more buttons in the specified direction, the function will return an empty
 * string, meaning that there is no focusable element in that direction.
 * @param {String} direction  specifies the direction on which the closest button needs to be found. Possible values are
 * "left" or "right".
 * @param {Array} buttonsList The list of buttons to be used to look for the closest item for a given button.
 * @param {Number} index  The index in the array of the button whose closest item in a given direction needs to be
 * found.
 * @return {string} The focus path of the closest button found in the received direction or empty string is no more
 * buttons were present in the mentioned direction.
 */
function getClosestButtonFocusPath(direction, buttonsList, index) {
  const appDirection = i18n.getDirection();
  let newIndex = null;
  const getClosestPreviousButton = () => {
    if (index === 0) {
      return "";
    } else {
      return index - 1;
    }
  };
  const getClosestNextButton = () => {
    if (index === buttonsList.length - 1) {
      return "";
    } else {
      return index + 1;
    }
  };

  if (direction === "up") {
    newIndex = getClosestPreviousButton();
  } else if (direction === "down") {
    newIndex = getClosestNextButton();
  } else {
    if (appDirection === i18n.directions.LEFT_TO_RIGHT) {
      if (direction === "left") {
        newIndex = getClosestPreviousButton();
      } else if (direction === "right") {
        newIndex = getClosestNextButton();
      }
    } else if (appDirection === i18n.directions.RIGHT_TO_LEFT) {
      if (direction === "right") {
        newIndex = getClosestPreviousButton();
      } else if (direction === "left") {
        newIndex = getClosestNextButton();
      }
    }
  }
  return newIndex === "" ? "" : "@" + buttonsList[newIndex].focusPath;
}
